import React from "react";
import {
    faRobot,
    faCircleInfo,
    faGift,
    faPhone,
    faCartShopping,
    faClockRotateLeft,
    faFire,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ROUTES } from "./filtvConstants";

const ActionButton = ({ icon, title, color, onClick, disabled }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        className={`flex flex-col items-center justify-center rounded-xl bg-zinc-900 transition-all duration-200 active:scale-95 p-3 min-w-[68px] border border-zinc-800
        ${disabled
            ? "opacity-40 cursor-not-allowed"
            : "hover:bg-purple-700 hover:border-purple-400"
        }`}
    >
        <FontAwesomeIcon icon={icon} className={`text-lg ${color}`} />
        <span className="text-[10px] mt-1.5 text-white text-center">{title}</span>
    </button>
);

export default function FILTVBottomBar({ ad }) {
    const hasAd = Boolean(ad);

    return (
        <div className="bg-zinc-950 border-t border-zinc-800 sticky bottom-0 z-30">
            <div className="flex gap-2 overflow-x-auto p-2.5 scrollbar-hide">
                <ActionButton
                    icon={faRobot}
                    title="Digital Twin"
                    color="text-cyan-400"
                    disabled={!hasAd}
                    onClick={() =>
                        hasAd && (window.location.href = ROUTES.digitalTwin(ad.advertisementCode))
                    }
                />

                <ActionButton
                    icon={faCircleInfo}
                    title="Details"
                    color="text-blue-400"
                    disabled={!hasAd}
                    onClick={() => hasAd && (window.location.href = ROUTES.product(ad.cartProductCode))}
                />

                <ActionButton
                    icon={faGift}
                    title="Offer"
                    color="text-pink-400"
                    disabled={!hasAd}
                    onClick={() => hasAd && (window.location.href = ROUTES.product(ad.cartProductCode))}
                />

                <ActionButton
                    icon={faWhatsapp}
                    title="WhatsApp"
                    color="text-green-500"
                    disabled={!ad?.whatsapp}
                    onClick={() =>
                        ad?.whatsapp && window.open(`https://wa.me/${ad.whatsapp.replace("+", "")}`)
                    }
                />

                <ActionButton
                    icon={faPhone}
                    title="Call"
                    color="text-orange-400"
                    disabled={!ad?.phone}
                    onClick={() => ad?.phone && (window.location.href = `tel:${ad.phone}`)}
                />

                <ActionButton
                    icon={faCartShopping}
                    title="Order"
                    color="text-yellow-400"
                    disabled={!hasAd}
                    onClick={() => hasAd && (window.location.href = ROUTES.product(ad.cartProductCode))}
                />

                <ActionButton
                    icon={faClockRotateLeft}
                    title="History"
                    color="text-indigo-400"
                    onClick={() => (window.location.href = ROUTES.orderHistory)}
                />

                <ActionButton
                    icon={faFire}
                    title="Streaks"
                    color="text-red-500"
                    onClick={() => console.log("PDStreaks")}
                />
            </div>
        </div>
    );
}
